/**
 * Popup video – only runs when Magnific Popup is loaded (conditionally enqueued with shortcode).
 */

import $ from "jquery";

const options = {
	disableOn: 700,
	type: "iframe",
	mainClass: "mfp-fade",
	removalDelay: 160,
	preloader: false,
	fixedContentPos: false,
};

function initMagnific() {
	if (typeof $.fn.magnificPopup !== "function") return false;
	$(".js-popup-video").magnificPopup(options);
	return true;
}

if (!initMagnific()) {
	// Plugin is loaded in footer after this bundle; try again once it might be available
	const check = () => {
		if (typeof $.fn.magnificPopup === "function") {
			$(".js-popup-video").magnificPopup(options);
			return true;
		}
		return false;
	};
	setTimeout(check, 0);
	setTimeout(check, 100);
}
